export const YellowRectangle = () => {
  return (
    <svg width="19" height="23" viewBox="0 0 19 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.6738 2.32812L4.23177 19.9272" stroke="#FBA664" stroke-width="8.65463" />
    </svg>
  );
};
